export default __webpack_public_path__ + "static/droneDetection-7935b8f769c02a7da8bcc49cc5af3d30.png";